// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__-1iGK","header":"MergedInvoice_header__2PCYR"};